if (!window.customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      const trigger = this.querySelector('.trigger')
      const mark = this.querySelector('.scroll-mark');

      if (!mark || !trigger) return

      trigger.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }))
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.boundingClientRect.top < 0) {
            trigger.ariaHidden = String(entry.isIntersecting)
          } else {
            trigger.ariaHidden = 'true';
          }
        })
      }, {}).observe(mark);
    }
  }
  
  customElements.define('back-to-top', BackToTop);
}